import React, { useState } from 'react';
import UpsetPlot from './UpsetPlot';
import {
  Grid,
  Paper,
  Typography,
  Button,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
} from '@material-ui/core';
import { countOrACVFormatter } from '../../util/customFunctions';
import { upsetData } from './Data';

function UpsetPlotPage() {
  const [state, setState] = useState({
    industry: 'All Industries',
    activeIndustry: 'All Industries', // Track the industry currently displayed
  });

  // Get all available industries from upsetData
const getAvailableIndustries = () => {
  const industries = Object.keys(upsetData);
  
  // Separate "All Industries" from the rest
  const allIndustries = industries.filter(ind => ind === 'All Industries');
  const otherIndustries = industries
    .filter(ind => ind !== 'All Industries')
    .sort((a, b) => a.localeCompare(b)); // Alphabetical sort
  
  // Return with "All Industries" at the top
  return [...allIndustries, ...otherIndustries];
};

  // Handle industry change (only updates dropdown, not the plot)
  const handleIndustryChange = (e) => {
    setState({
      ...state,
      industry: e.target.value,
    });
  };

  // Handle GO button click (updates the plot)
  const handleGo = () => {
    setState({
      ...state,
      activeIndustry: state.industry, // Update active industry to trigger plot update
    });
  };

  // Get data based on active industry
  const rawData = upsetData[state.activeIndustry];
  const data = {
    ...rawData,
    intersections: rawData.intersections
      .sort((a, b) => b.size - a.size)
      .slice(0, 45)
  };

  // Optional: Custom configuration
  const config = {
    width: 1200,
    height: 600,
    margin: { top: 60, right: 40, bottom: 60, left: 200 },
    barChart: {
      height: 250,
      barPadding: 0.2
    },
    matrix: {
      height: 200,
      dotRadius: 5
    },
    setChart: {
      width: 150
    },
    colors: {
      bar: 'steelblue',
      barHover: '#4682b4',
      setBar: '#555',
      dot: '#4682b4',
      line: '#4472b4'
    }
  };

  return (
    <div style={{ padding: '20px', background: 'white', minHeight: '100vh' }}>
      {/* Filter Section */}
      <Grid container style={{ marginBottom: '20px' }}>
        {/* Industry Filter */}
        <Grid
          container
          item
          style={{ padding: 10, paddingTop: 15 }}
          xs={2}
          md={2}
        >
          <Grid item spacing={2} xs={12} container component={Paper}>
            <Grid item xs={12}>
              <FormControl fullWidth>
                <InputLabel
                  id="select-industry-label"
                  style={{ 
                    color: state.industry !== 'All Industries' ? "#4472c4" : "#000" 
                  }}
                >
                  Industry:
                </InputLabel>
                <Select
                  data-test="industry"
                  labelId="select-industry-label"
                  id="industry"
                  value={state.industry}
                  onChange={handleIndustryChange}
                  label="Industry"
                  name="industry"
                >
                  {getAvailableIndustries().map((industry) => (
                    <MenuItem key={industry} value={industry}>
                      {industry === 'All Industries' ? 'All' : industry}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </Grid>
        </Grid>

        {/* GO Button */}
        <Grid
          container
          item
          style={{ padding: 10, paddingTop: 15 }}
          xs={12}
          md={2}
          alignItems="center"
        >
          <Grid item xs={12} container justify="flex-start">
            <Button
              data-test="go"
              variant="contained"
              color="primary"
              onClick={handleGo}
              style={{ height: '40px', marginTop: '8px' }}
            >
              GO
            </Button>
          </Grid>
        </Grid>
      </Grid>

      {/* Title Section */}
      <h1 style={{ textAlign: 'center', color: '#333' }}>
        Product co-usage in the installed base ({state.activeIndustry})
      </h1>
      <Typography variant='h2' align='center'>
        Total Accounts: {countOrACVFormatter(data.total_accounts)}
      </Typography>

      {/* UpSet Plot */}
      <UpsetPlot data={data} config={config} />
    </div>
  );
}

export default UpsetPlotPage;